import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
};

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    loadingHandler: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { loadingHandler } = loadingSlice.actions;
export default loadingSlice.reducer;
